module.exports = __webpack_public_path__ + "img/car-4.835d5d67.jpg";